import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/order-products',
      name: 'order_products',
      component: () => import(/* webpackChunkName: "about" */ './components/order_products.vue')
    },
    {
      path: '/submit-return',
      name: 'submit_return',
      component: () => import(/* webpackChunkName: "about" */ './components/submit_return.vue')
    },
    {
      path: '/success-return',
      name: 'success_return',
      component: () => import(/* webpackChunkName: "about" */ './components/success_return.vue')
    }
  ]
})
